module.exports = __webpack_public_path__ + "public/img/head_default.b423aa5c.png";